import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

export class UserMenuSubcategory extends Component {
  render() {
    const { children } = this.props;

    return <div className="user-menu-subcategory">
      <div className="user-menu-category-content">
        { children }
      </div>
      {/* <hr/> */}
    </div>;
  }
}

UserMenuSubcategory.propTypes = {
  children: PropTypes.oneOfType( [PropTypes.arrayOf( PropTypes.node ), PropTypes.node] )
};